import React from 'react';
import './login.css';

const LOGO_URL = 'https://hendler.co.uk/images/logo/HendlerMasterLogoWhite.svg';

export default function Login() {
  const handleLogin = () => {
    window.location.href = '/auth/azure/login';
  };

  return (
    <main className="login-shell">
      <section className="login-panel" aria-label="Sign in">
        <div className="login-card">
          <img src={LOGO_URL} alt="Hendler Wholesale" className="login-logo" loading="lazy" />
          <h1>Hendler PIM Portal</h1>
          <p>
            Sign in to the Hendler PIM to look up fitments, OEM references, and part information wherever you are.
          </p>
          <button type="button" className="login-button" onClick={handleLogin}>
            Sign in with Microsoft
          </button>
          <p className="login-meta">
            Securely log in with a Microsoft 365 account. Your business email must be registered with Hendler to gain access.
          </p>
          <p className="login-footnote">
            Need access? Email <a href="mailto:sales@hendler.co.uk">sales@hendler.co.uk</a> from your business email with your Hendler account number and let us know what you're after.
          </p>
        </div>
      </section>
      <section className="login-hero" aria-label="Platform highlights">
        <div>
          <div className="login-hero-badge">Product Information Manager</div>
          <h2 className="login-hero-heading">
            Hendler&apos;s PIM Portal
          </h2>
          <p className="login-hero-copy">
            This portal keeps Hendler&apos;s product information securely in one location.
          </p>
          <div className="login-hero-points">
            <div className="login-hero-point">
              <span>01</span>
              <p>Gain access to all of Hendler&apos;s product information in one secure location. Millions of fitments, OEM References, cross references. All at your fingertips.</p>
            </div>
            <div className="login-hero-point">
              <span>02</span>
              <p>Hendler's PartFinder returns fitments at lightning speed, all complete with extra detail such as OEM References and images, gaining access to behind the scenes information.</p>
            </div>
            <div className="login-hero-point">
              <span>03</span>
              <p>Live stock and pricing for your account.</p>
            </div>
            <div className="login-hero-point">
              <span>04</span>
              <p>New features are being added on a regular basis. Coming soon - Custom Reports on fitments, with csv/excel exports, grouped years and customised titles for your listings.</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
